

export default {
  tenantName: 'Vlaanderen',
  tenantAcronym: 'VLA',
  tenantSlug: 'vlaanderen',

  /**
   * Feature Access checks
   */
  access: {
    chargingpoints: ['cpo', 'municipality'],
    requestlist: ['cpo'],
    requestlocations: ['cpo', 'municipality'],
    realisationlist: ['cpo', 'municipality'],
    realisationbtn: ['cpo'],
    realisationcomment: ['cpo', 'municipality'],
    canConfirmTrafficDecisions: ['municipality'],
    canChangeCommentStatus: ['cpo', 'municipality'],
    canChangeStatus: ['cpo', 'municipality'],
    automatedViews: ['cpo'],
    generateStartDoc: ['cpo', 'municipality'],
    admin: ['admin'],
    reporting: ['admin'],
    eventlog: [],
    manuals: ['cpo', 'municipality', 'admin'],
    export: ['admin'],
  },


  /**
   * Judgement Reasons
   */
  reasonOptions: [
    // Accept
    { status: 3, value: 1, text: 'Geen laadpaal beschikbaar', short: 'Geen laadpaal', custom: true, placeholder: 'Er is geen laadpaal beschikbaar binnen 250m' },
    { status: 3, value: 2, text: 'Paal bijplaatsen', short: 'Bijplaatsen', custom: true, placeholder: 'Er is wel een laadpaal beschikbaar binnen 250m, maar deze is te veel bezet. Er mag een paal bijgeplaatst worden.' },
    // Reject
    { status: 4, value: 3, text: 'Laadpaal beschikbaar', short: 'Laadpaal beschikbaar', custom: true, placeholder: 'Er is al een laadpaal aanwezig binnen 250m en die is voldoende beschikbaar' },
    { status: 4, value: 4, text: 'Anders', short: 'Anders', custom: true, placeholder: 'Schrijf hier je toelichting.' },
  ],

  /**
   * Monitoring config
   */
  monitoring: {
    enabled: false,
    limit: 0.5,
  },
  /**
     * Default benchmark menu, used in realisation reporting average step time
     *
     * @type {Object}
   */
  benchmarkMenu: [
    { name: 'Gemeente', target: 'municipalityOptions' },
    { name: 'Netbeheerder', target: 'gridOperators' },
    { name: 'Type realisatiproces', target: 'getProcessTypeOptions' },
    { name: 'Aantal palen per RP', target: 'recordsByNumberOfChargingStations' },
  ],

  /**
   * Diameter of the location picker in meters
   */
  LocationPickerDiameter: 250,

  /**
   * CPO field specific for Vlaanderen
   */

  chargePointOperatorField: {
    'type': 'string',
    'title': 'CPO',
    'format': 'select',
    'options': [
      { 'value': 'TotalEnergies', 'text': 'TotalEnergies' },
      { 'value': 'Engie', 'text': 'Engie' },
    ],
    'disabled': false,
    'placeholder': 'Selecteer CPO',
  },

  /**
   * Logo and other possible tenant images config
   */
  image: {
    file: 'vlaanderen.png',
    width: 160,
  },

  /**
   * Map options config
   */
  mapOptions: {
    countries: 'be, nl',
    center: [4.4477809, 51.0950244],
    zoom: 8,
  },


  /**
   * search
   */
  search: {
    requests: {
      keys: ['summary.name', 'summary.address', 'case_ref', 'ref', 'uuid', 'search.postalcode', 'search.city'],
      placeholder: 'Zoek op referentie, naam, adres of plaats',
    },
    realisations: {
      keys: ['case_ref', 'search.Municipality', 'search.City', 'address', 'status.label', 'values.Location.PlannedRealisation.Contractor', 'values.Location.GridOperator', 'ref', 'uuid'],
      placeholder: 'Zoek op referentie, adres of stap',
    },
  },


  /**
   * onHold & cancel reasons
   */
  onHoldReasons: [{
    text: 'Bezwaar VKB binnengekomen',
    value: 'vkb',
  }, {
    text: 'Overige',
    value: 'other',
  }],

  cancelReasons: [{
    text: 'Bezwaar VKB toegewezen',
    value: 'vkb',
  }, {
    text: 'Overige',
    value: 'other',
  }],

  ChargingStationVersion: [],

  /**
   * Municipality Options
   */
  municipalityOptions: [
    { value: '41002', text: 'Aalst', disabled: false },
    { value: '44084', text: 'Aalter', disabled: false },
    { value: '24001', text: 'Aarschot', disabled: false },
    { value: '11001', text: 'Aartselaar', disabled: false },
    { value: '23105', text: 'Affligem', disabled: false },
    { value: '73001', text: 'Alken', disabled: false },
    { value: '38002', text: 'Alveringem', disabled: false },
    { value: '34002', text: 'Anzegem', disabled: false },
    { value: '37020', text: 'Ardooie', disabled: false },
    { value: '13001', text: 'Arendonk', disabled: false },
    { value: '71002', text: 'As', disabled: false },
    { value: '23002', text: 'Asse', disabled: false },
    { value: '43002', text: 'Assenede', disabled: false },
    { value: '34003', text: 'Avelgem', disabled: false },
    { value: '13002', text: 'Baarle-Hertog', disabled: false },
    { value: '13003', text: 'Balen', disabled: false },
    { value: '31003', text: 'Beernem', disabled: false },
    { value: '13004', text: 'Beerse', disabled: false },
    { value: '23003', text: 'Beersel', disabled: false },
    { value: '24007', text: 'Begijnendijk', disabled: false },
    { value: '24008', text: 'Bekkevoort', disabled: false },
    { value: '71004', text: 'Beringen', disabled: false },
    { value: '12002', text: 'Berlaar', disabled: false },
    { value: '42003', text: 'Berlare', disabled: false },
    { value: '24009', text: 'Bertem', disabled: false },
    { value: '23009', text: 'Bever', disabled: false },
    { value: '46003', text: 'Beveren', disabled: false },
    { value: '24011', text: 'Bierbeek', disabled: false },
    { value: '73006', text: 'Bilzen', disabled: false },
    { value: '31004', text: 'Blankenberge', disabled: false },
    { value: '72003', text: 'Bocholt', disabled: false },
    { value: '11004', text: 'Boechout', disabled: false },
    { value: '12005', text: 'Bonheiden', disabled: false },
    { value: '11005', text: 'Boom', disabled: false },
    { value: '24014', text: 'Boortmeerbeek', disabled: false },
    { value: '73009', text: 'Borgloon', disabled: false },
    { value: '12007', text: 'Bornem', disabled: false },
    { value: '11007', text: 'Borsbeek', disabled: false },
    { value: '24016', text: 'Boutersem', disabled: false },
    { value: '45059', text: 'Brakel', disabled: false },
    { value: '11008', text: 'Brasschaat', disabled: false },
    { value: '11009', text: 'Brecht', disabled: false },
    { value: '35002', text: 'Bredene', disabled: false },
    { value: '72004', text: 'Bree', disabled: false },
    { value: '31005', text: 'Brugge', disabled: false },
    { value: '42004', text: 'Buggenhout', disabled: false },
    { value: '31006', text: 'Damme', disabled: false },
    { value: '35029', text: 'De Haan', disabled: false },
    { value: '38008', text: 'De Panne', disabled: false },
    { value: '44012', text: 'De Pinte', disabled: false },
    { value: '34009', text: 'Deerlijk', disabled: false },
    { value: '44083', text: 'Deinze', disabled: false },
    { value: '41011', text: 'Denderleeuw', disabled: false },
    { value: '42006', text: 'Dendermonde', disabled: false },
    { value: '37002', text: 'Dentergem', disabled: false },
    { value: '13006', text: 'Dessel', disabled: false },
    { value: '44013', text: 'Destelbergen', disabled: false },
    { value: '71011', text: 'Diepenbeek', disabled: false },
    { value: '24020', text: 'Diest', disabled: false },
    { value: '32003', text: 'Diksmuide', disabled: false },
    { value: '23016', text: 'Dilbeek', disabled: false },
    { value: '72041', text: 'Dilsen-Stokkem', disabled: false },
    { value: '23098', text: 'Drogenbos', disabled: false },
    { value: '12009', text: 'Duffel', disabled: false },
    { value: '11013', text: 'Edegem', disabled: false },
    { value: '43005', text: 'Eeklo', disabled: false },
    { value: '41082', text: 'Erpe-Mere', disabled: false },
    { value: '11016', text: 'Essen', disabled: false },
    { value: '44019', text: 'Evergem', disabled: false },
    { value: '23023', text: 'Galmaarden', disabled: false },
    { value: '44020', text: 'Gavere', disabled: false },
    { value: '13008', text: 'Geel', disabled: false },
    { value: '24028', text: 'Geetbets', disabled: false },
    { value: '41018', text: 'Geraardsbergen', disabled: false },
    { value: '71017', text: 'Gingelom', disabled: false },
    { value: '35005', text: 'Gistel', disabled: false },
    { value: '24137', text: 'Glabbeek', disabled: false },
    { value: '23024', text: 'Gooik', disabled: false },
    { value: '23025', text: 'Grimbergen', disabled: false },
    { value: '13010', text: 'Grobbendonk', disabled: false },
    { value: '24033', text: 'Haacht', disabled: false },
    { value: '41024', text: 'Haaltert', disabled: false },
    { value: '71020', text: 'Halen', disabled: false },
    { value: '23027', text: 'Halle', disabled: false },
    { value: '71069', text: 'Ham', disabled: false },
    { value: '42008', text: 'Hamme', disabled: false },
    { value: '72037', text: 'Hamont-Achel', disabled: false },
    { value: '34013', text: 'Harelbeke', disabled: false },
    { value: '71022', text: 'Hasselt', disabled: false },
    { value: '72038', text: 'Hechtel-Eksel', disabled: false },
    { value: '73022', text: 'Heers', disabled: false },
    { value: '12014', text: 'Heist-op-den-Berg', disabled: false },
    { value: '11018', text: 'Hemiksem', disabled: false },
    { value: '24038', text: 'Herent', disabled: false },
    { value: '13011', text: 'Herentals', disabled: false },
    { value: '13012', text: 'Herenthout', disabled: false },
    { value: '71024', text: 'Herk-de-Stad', disabled: false },
    { value: '23032', text: 'Herne', disabled: false },
    { value: '13013', text: 'Herselt', disabled: false },
    { value: '73028', text: 'Herstappe', disabled: false },
    { value: '41027', text: 'Herzele', disabled: false },
    { value: '71070', text: 'Heusden-Zolder', disabled: false },
    { value: '33039', text: 'Heuvelland', disabled: false },
    { value: '24041', text: 'Hoegaarden', disabled: false },
    { value: '23033', text: 'Hoeilaart', disabled: false },
    { value: '73032', text: 'Hoeselt', disabled: false },
    { value: '24043', text: 'Holsbeek', disabled: false },
    { value: '36006', text: 'Hooglede', disabled: false },
    { value: '13014', text: 'Hoogstraten', disabled: false },
    { value: '45062', text: 'Horebeke', disabled: false },
    { value: '72039', text: 'Houthalen-Helchteren', disabled: false },
    { value: '32006', text: 'Houthulst', disabled: false },
    { value: '11021', text: 'Hove', disabled: false },
    { value: '24045', text: 'Huldenberg', disabled: false },
    { value: '13016', text: 'Hulshout', disabled: false },
    { value: '35006', text: 'Ichtegem', disabled: false },
    { value: '33011', text: 'Ieper', disabled: false },
    { value: '36007', text: 'Ingelmunster', disabled: false },
    { value: '36008', text: 'Izegem', disabled: false },
    { value: '31012', text: 'Jabbeke', disabled: false },
    { value: '11022', text: 'Kalmthout', disabled: false },
    { value: '23038', text: 'Kampenhout', disabled: false },
    { value: '23039', text: 'Kapelle-op-den-Bos', disabled: false },
    { value: '11023', text: 'Kapellen', disabled: false },
    { value: '43007', text: 'Kaprijke', disabled: false },
    { value: '13017', text: 'Kasterlee', disabled: false },
    { value: '24048', text: 'Keerbergen', disabled: false },
    { value: '72018', text: 'Kinrooi', disabled: false },
    { value: '45060', text: 'Kluisbergen', disabled: false },
    { value: '31043', text: 'Knokke-Heist', disabled: false },
    { value: '32010', text: 'Koekelare', disabled: false },
    { value: '38014', text: 'Koksijde', disabled: false },
    { value: '11024', text: 'Kontich', disabled: false },
    { value: '32011', text: 'Kortemark', disabled: false },
    { value: '24054', text: 'Kortenaken', disabled: false },
    { value: '24055', text: 'Kortenberg', disabled: false },
    { value: '73040', text: 'Kortessem', disabled: false },
    { value: '34022', text: 'Kortrijk', disabled: false },
    { value: '23099', text: 'Kraainem', disabled: false },
    { value: '46013', text: 'Kruibeke', disabled: false },
    { value: '45068', text: 'Kruisem', disabled: false },
    { value: '34023', text: 'Kuurne', disabled: false },
    { value: '13053', text: 'Laakdal', disabled: false },
    { value: '42010', text: 'Laarne', disabled: false },
    { value: '73042', text: 'Lanaken', disabled: false },
    { value: '24059', text: 'Landen', disabled: false },
    { value: '33040', text: 'Langemark-Poelkapelle', disabled: false },
    { value: '42011', text: 'Lebbeke', disabled: false },
    { value: '41034', text: 'Lede', disabled: false },
    { value: '36010', text: 'Ledegem', disabled: false },
    { value: '34025', text: 'Lendelede', disabled: false },
    { value: '23104', text: 'Lennik', disabled: false },
    { value: '71034', text: 'Leopoldsburg', disabled: false },
    { value: '24062', text: 'Leuven', disabled: false },
    { value: '36011', text: 'Lichtervelde', disabled: false },
    { value: '23044', text: 'Liedekerke', disabled: false },
    { value: '12021', text: 'Lier', disabled: false },
    { value: '45063', text: 'Lierde', disabled: false },
    { value: '44085', text: 'Lievegem', disabled: false },
    { value: '13019', text: 'Lille', disabled: false },
    { value: '23100', text: 'Linkebeek', disabled: false },
    { value: '11025', text: 'Lint', disabled: false },
    { value: '24133', text: 'Linter', disabled: false },
    { value: '32030', text: 'Lo-Reninge', disabled: false },
    { value: '44034', text: 'Lochristi', disabled: false },
    { value: '46014', text: 'Lokeren', disabled: false },
    { value: '72020', text: 'Lommel', disabled: false },
    { value: '23045', text: 'Londerzeel', disabled: false },
    { value: '24066', text: 'Lubbeek', disabled: false },
    { value: '71037', text: 'Lummen', disabled: false },
    { value: '45064', text: 'Maarkedal', disabled: false },
    { value: '72021', text: 'Maaseik', disabled: false },
    { value: '73107', text: 'Maasmechelen', disabled: false },
    { value: '23047', text: 'Machelen', disabled: false },
    { value: '43010', text: 'Maldegem', disabled: false },
    { value: '11057', text: 'Malle', disabled: false },
    { value: '12025', text: 'Mechelen', disabled: false },
    { value: '13021', text: 'Meerhout', disabled: false },
    { value: '23050', text: 'Meise', disabled: false },
    { value: '44040', text: 'Melle', disabled: false },
    { value: '34027', text: 'Menen', disabled: false },
    { value: '23052', text: 'Merchtem', disabled: false },
    { value: '44043', text: 'Merelbeke', disabled: false },
    { value: '13023', text: 'Merksplas', disabled: false },
    { value: '33016', text: 'Mesen', disabled: false },
    { value: '37007', text: 'Meulebeke', disabled: false },
    { value: '35011', text: 'Middelkerke', disabled: false },
    { value: '44045', text: 'Moerbeke', disabled: false },
    { value: '13025', text: 'Mol', disabled: false },
    { value: '36012', text: 'Moorslede', disabled: false },
    { value: '11029', text: 'Mortsel', disabled: false },
    { value: '44048', text: 'Nazareth', disabled: false },
    { value: '11030', text: 'Niel', disabled: false },
    { value: '71045', text: 'Nieuwerkerken', disabled: false },
    { value: '38016', text: 'Nieuwpoort', disabled: false },
    { value: '12026', text: 'Nijlen', disabled: false },
    { value: '41048', text: 'Ninove', disabled: false },
    { value: '13029', text: 'Olen', disabled: false },
    { value: '35013', text: 'Oostende', disabled: false },
    { value: '44052', text: 'Oosterzele', disabled: false },
    { value: '31022', text: 'Oostkamp', disabled: false },
    { value: '37010', text: 'Oostrozebeke', disabled: false },
    { value: '23060', text: 'Opwijk', disabled: false },
    { value: '24086', text: 'Oud-Heverlee', disabled: false },
    { value: '13031', text: 'Oud-Turnhout', disabled: false },
    { value: '45035', text: 'Oudenaarde', disabled: false },
    { value: '35014', text: 'Oudenburg', disabled: false },
    { value: '72042', text: 'Oudsbergen', disabled: false },
    { value: '23062', text: 'Overijse', disabled: false },
    { value: '72030', text: 'Peer', disabled: false },
    { value: '72043', text: 'Pelt', disabled: false },
    { value: '23064', text: 'Pepingen', disabled: false },
    { value: '37011', text: 'Pittem', disabled: false },
    { value: '33021', text: 'Poperinge', disabled: false },
    { value: '12029', text: 'Putte', disabled: false },
    { value: '12041', text: 'Puurs-Sint-Amands', disabled: false },
    { value: '11035', text: 'Ranst', disabled: false },
    { value: '13035', text: 'Ravels', disabled: false },
    { value: '13036', text: 'Retie', disabled: false },
    { value: '73066', text: 'Riemst', disabled: false },
    { value: '13037', text: 'Rijkevorsel', disabled: false },
    { value: '36015', text: 'Roeselare', disabled: false },
    { value: '45041', text: 'Ronse', disabled: false },
    { value: '23097', text: 'Roosdaal', disabled: false },
    { value: '24094', text: 'Rotselaar', disabled: false },
    { value: '37012', text: 'Ruiselede', disabled: false },
    { value: '11037', text: 'Rumst', disabled: false },
    { value: '11038', text: 'Schelle', disabled: false },
    { value: '24134', text: 'Scherpenheuvel-Zichem', disabled: false },
    { value: '11039', text: 'Schilde', disabled: false },
    { value: '11040', text: 'Schoten', disabled: false },
    { value: '23101', text: 'Sint-Genesius-Rode', disabled: false },
    { value: '46020', text: 'Sint-Gillis-Waas', disabled: false },
    { value: '12035', text: 'Sint-Katelijne-Waver', disabled: false },
    { value: '43014', text: 'Sint-Laureins', disabled: false },
    { value: '41063', text: 'Sint-Lievens-Houtem', disabled: false },
    { value: '44064', text: 'Sint-Martens-Latem', disabled: false },
    { value: '46021', text: 'Sint-Niklaas', disabled: false },
    { value: '23077', text: 'Sint-Pieters-Leeuw', disabled: false },
    { value: '71053', text: 'Sint-Truiden', disabled: false },
    { value: '34043', text: 'Spiere-Helkijn', disabled: false },
    { value: '11044', text: 'Stabroek', disabled: false },
    { value: '36019', text: 'Staden', disabled: false },
    { value: '23081', text: 'Steenokkerzeel', disabled: false },
    { value: '46024', text: 'Stekene', disabled: false },
    { value: '46025', text: 'Temse', disabled: false },
    { value: '23086', text: 'Ternat', disabled: false },
    { value: '24104', text: 'Tervuren', disabled: false },
    { value: '71057', text: 'Tessenderlo', disabled: false },
    { value: '37015', text: 'Tielt', disabled: false },
    { value: '24135', text: 'Tielt-Winge', disabled: false },
    { value: '24107', text: 'Tienen', disabled: false },
    { value: '73083', text: 'Tongeren', disabled: false },
    { value: '31033', text: 'Torhout', disabled: false },
    { value: '24109', text: 'Tremelo', disabled: false },
    { value: '13040', text: 'Turnhout', disabled: false },
    { value: '38025', text: 'Veurne', disabled: false },
    { value: '23088', text: 'Vilvoorde', disabled: false },
    { value: '33041', text: 'Vleteren', disabled: false },
    { value: '73109', text: 'Voeren', disabled: false },
    { value: '13044', text: 'Vorselaar', disabled: false },
    { value: '13046', text: 'Vosselaar', disabled: false },
    { value: '42023', text: 'Waasmunster', disabled: false },
    { value: '44073', text: 'Wachtebeke', disabled: false },
    { value: '34040', text: 'Waregem', disabled: false },
    { value: '73098', text: 'Wellen', disabled: false },
    { value: '23102', text: 'Wemmel', disabled: false },
    { value: '33029', text: 'Wervik', disabled: false },
    { value: '13049', text: 'Westerlo', disabled: false },
    { value: '42025', text: 'Wetteren', disabled: false },
    { value: '34041', text: 'Wevelgem', disabled: false },
    { value: '23103', text: 'Wezembeek-Oppem', disabled: false },
    { value: '42026', text: 'Wichelen', disabled: false },
    { value: '37017', text: 'Wielsbeke', disabled: false },
    { value: '11050', text: 'Wijnegem', disabled: false },
    { value: '12040', text: 'Willebroek', disabled: false },
    { value: '37018', text: 'Wingene', disabled: false },
    { value: '11052', text: 'Wommelgem', disabled: false },
    { value: '45061', text: 'Wortegem-Petegem', disabled: false },
    { value: '11053', text: 'Wuustwezel', disabled: false },
    { value: '11054', text: 'Zandhoven', disabled: false },
    { value: '23094', text: 'Zaventem', disabled: false },
    { value: '31040', text: 'Zedelgem', disabled: false },
    { value: '42028', text: 'Zele', disabled: false },
    { value: '43018', text: 'Zelzate', disabled: false },
    { value: '23096', text: 'Zemst', disabled: false },
    { value: '11055', text: 'Zoersel', disabled: false },
    { value: '71066', text: 'Zonhoven', disabled: false },
    { value: '33037', text: 'Zonnebeke', disabled: false },
    { value: '41081', text: 'Zottegem', disabled: false },
    { value: '24130', text: 'Zoutleeuw', disabled: false },
    { value: '31042', text: 'Zuienkerke', disabled: false },
    { value: '44081', text: 'Zulte', disabled: false },
    { value: '71067', text: 'Zutendaal', disabled: false },
    { value: '45065', text: 'Zwalm', disabled: false },
    { value: '34042', text: 'Zwevegem', disabled: false },
    { value: '11056', text: 'Zwijndrecht', disabled: false },
  ],

  /**
   * Commonly used contractors by grid operator
   * @type {Object}
   */
  contractorsByGridOperator: {},

  supportEmailAddress: 'support@evtools.be',
}


